import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {
  SupportTradeDataLoadingService
} from "../../../../services/support/support-trade/support-trade-data-loading.service";
import {Trade} from "../../../../model/clearing/trade";
import {SupportTradeService} from "../../../../services/support/support-trade/support-trade.service";
import {
  SupportTradeBatchFormConfigService
} from "../../../../services/support/support-trade/support-trade-batch-form-config.service";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {BatchActionBaseFormComponent} from "../../../../crystal-elements/batch-action-base-form.component";
import {DecimalPipe} from "@angular/common";
import {PrepareForSaveDateFields} from "../../../../utils/form-helper";

@Component({
  selector: 'app-batch-action-support-trade-form',
  templateUrl: './batch-action-support-trade-form.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchActionSupportTradeFormComponent
  extends BatchActionBaseFormComponent<Trade, SupportTradeBatchFormConfigService> {

  @Input()
  dataLoadingService: SupportTradeDataLoadingService

  constructor(
    cdref: ChangeDetectorRef,
    messageService: MessageService,
    translateService: TranslateService,
    confirmationService: ConfirmationService,
    formConfigService: SupportTradeBatchFormConfigService,
    private readonly supportTradeService: SupportTradeService
  ) {
    super(
      cdref,
      messageService,
      translateService,
      confirmationService,
      formConfigService
    );
  }

  protected getSaveAction(request: BatchUpdateRequest<Trade>) {
    PrepareForSaveDateFields(request.recordToApply, this.formConfig);
    return this.supportTradeService.saveBatch(request);
  }
}
